import { render, staticRenderFns } from "./DigitalLiteracy.vue?vue&type=template&id=4d34f264&scoped=true&"
import script from "./DigitalLiteracy.vue?vue&type=script&lang=js&"
export * from "./DigitalLiteracy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d34f264",
  null
  
)

export default component.exports